export default __webpack_public_path__ + "static/media/Marianne-Medium_Italic.e31b8af2.woff2";